var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checckbox_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details-01",
    transform: "translate(-466.000000, -947.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(435.000000, 799.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checckbox_on",
    transform: "translate(11.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#95C11F",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7160547,8.2840625 C16.3373047,7.9053125 15.7238672,7.9053125 15.3451172,8.2840625 L10.5441797,13.0828125 L8.6554297,11.1921875 C8.2766797,10.813125 7.6632422,10.813125 7.2841797,11.1921875 C6.9051172,11.57125 6.9054297,12.18625 7.2841797,12.563125 L9.8154297,15.09625 C9.8291797,15.111875 9.8429297,15.125625 9.8563672,15.14125 C10.0457422,15.330625 10.2957422,15.4265625 10.5438672,15.4244116 C10.7919922,15.4244116 11.0419922,15.330625 11.2313672,15.14125 C11.2469922,15.125625 11.2607422,15.111875 11.2741797,15.09625 L16.7157422,9.6546875 C17.0926172,9.2778125 17.0926172,8.6625 16.7157422,8.2834375 L16.7160547,8.2840625 Z",
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox_on.fb5a828a52125985434cc41bf9b6f193.svg";
export { ForwardRef as ReactComponent };